module.exports = __webpack_public_path__ + "static/media/wsp-fail.63e80240.svg";